import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Notification(toastMessageType, toastMessage) {
  if(toastMessageType === 1) {
    toast.success(toastMessage, {
      className: 'zz-notifcation',
      position: "bottom-right",
      autoClose: 3000,
      newestOnTop: true,
      hideProgressBar: false,
      pauseOnFocusLoss: false,
      closeOnClick: true,
      draggable: true,
    })
  } else if (toastMessageType === 2) {
    toast.error(toastMessage, {
      className: 'zz-notifcation',
      position: "bottom-right",
      autoClose: 3000,
      newestOnTop: true,
      hideProgressBar: false,
      pauseOnFocusLoss: false,
      closeOnClick: true,
      draggable: true,
    })
  }
}
